export default function commerce7Observer() {
  // Select the target element to observe
  const targetElement = document.getElementById('c7-account')

  function updateLinkText() {
    // Find all links inside the #cart element
    const link = targetElement?.querySelector('a')

    if (link && link.textContent === 'Log in') {
      link.textContent = 'Account Login'
    }
  }

  // Create a new MutationObserver instance
  const observer = new MutationObserver((mutations) => {
    // For each mutation that occurred
    mutations.forEach(() => {
      // Call the function to update link text
      updateLinkText()
    })
  })

  // Configuration for the observer (what changes to watch for)
  const config = {
    childList: true,
    subtree: true,
    characterData: false,
    attributes: false,
  }

  // Start observing the target element if it exists
  if (targetElement) {
    updateLinkText()

    observer.observe(targetElement, config)
  }
}
